import { FormActions } from "../../components/common/FormActions";
import {
  createColumn,
  createViewEdit,
  formatDate,
  getForm,
  stringifyName,
} from "../../utils/helpers";
import { URL_INTEREST_CONFIGURABLES } from "../../utils/urls";

export const useInterestConfigurables = () => {
  const tableColumns = () => [
    ...[
      "purpose",
      "interest",
      "status",
      "default",
      "created_at",
      "actions",
    ].map((item) => createColumn(item)),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        created_at: formatDate(item.created_at),
        default: item?.default ? "True" : "False",
        actions: (
          <FormActions
            actions={createViewEdit(URL_INTEREST_CONFIGURABLES, item?.id)}
          />
        ),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      purpose: item?.purpose,
      interest: item?.interest,
      status: item?.status,
      created_by: stringifyName({ ...item?.created_by }),
      created_at: formatDate(item?.created_at),
    };
  };

  const formRoute = getForm(URL_INTEREST_CONFIGURABLES);
  return { tableColumns, tableData, formRoute, viewData };
};
